<p-panel
  header="Payment Summary"
  class="transaction-payment-details-display-card"
  data-cy="transaction-payment-details-display-card"
>
  <iframe width="100%" height="465" [src]="iframeSrc"></iframe>
</p-panel>
